export const SETTINGS_MODAL_OPEN_EVENT = 'luckynote:open-settings-modal';

export const SETTINGS_MODAL_TAB = {
    PROFILE: 'profile',
    UPGRADES: 'upgrades',
    BILLING_USAGE: 'billing_usage',
    INTEGRATIONS: 'integrations',
    MEMORY: 'memory',
    ACTIONS: 'actions'
};

export const openSettingsModal = (tab = SETTINGS_MODAL_TAB.UPGRADES, options = {}) => {
    if (typeof window === 'undefined') {
        return;
    }

    window.dispatchEvent(
        new CustomEvent(SETTINGS_MODAL_OPEN_EVENT, {
            detail: {
                tab,
                focusSearchEngine: options?.focusSearchEngine === true,
                ...(options || {})
            }
        })
    );
};
